module.exports = __webpack_public_path__ + "static/media/Standard.11.441110ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/standard/images/Standard.11.jpg
// module id = 678
// module chunks = 0